// Wrapper component to filter out google-map-react's $hover prop from DOM elements
import React from 'react'

interface MarkerWrapperProps {
  lat: number
  lng: number
  $hover?: boolean
  $getDimensions?: any
  $dimensionKey?: string
  $geoService: any
  $onMouseAllow: any
  $prerender?: any
  children: React.ReactNode
  setRef?: (el: HTMLDivElement | null) => void
}

export const MarkerWrapper: React.FC<MarkerWrapperProps> = ({
  lat: _lat,
  lng: _lng,
  children,
  // Destructure these to prevent them from being passed to DOM
  $hover: _hover,
  $getDimensions: _getDimensions,
  $dimensionKey: _dimensionKey,
  $geoService: _geoService,
  $onMouseAllow: _onMouseAllow,
  $prerender: _prerender,
  setRef,
  ...rest
}) => (
  <div ref={setRef} {...rest}>
    {children}
  </div>
)
